import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import clsx from 'clsx';
import { UserInfoModal } from 'components';
import { useModal } from 'hooks';
import {
  makeInvoiceStart,
  makePaymentWithoutOfficialBill,
} from 'redux/payments/payments.actions';
import UpgradeMethodModal from '../UpgradeMethodModal';
import styles from './InputPaymentInfoModal.module.scss';
import useTranslation from 'hooks/useTranslation';
import { needToCheckUserInfoForcedFields } from 'utils/validation';

const mapState = (state) => ({
  profile: state.userData.profile,
  isOfficialBillNeeded: state.paymentsData.isOfficialBillNeeded,
  selectedPackage: state.paymentsData.selectedPackage,
  selectedPackageType: state.paymentsData.selectedPackageType,
  selectedDuration: state.paymentsData.selectedDuration,
  discountCode: state.paymentsData.discountCode,
  useCredit: state.paymentsData.useCredit,
  invoiceId: state.paymentsData.invoiceId,
  selectedConversationCount: state.paymentsData.selectedConversationCount,
  payablePrice: state.paymentsData.payablePrice,
  paymentInfo: state.paymentsData.paymentInfo,
  locale: state.appData.locale,
});

const InputPaymentInfoModal = ({ isPackageUpgrade }) => {
  const dispatch = useDispatch();
  const {
    profile,
    isOfficialBillNeeded,
    selectedPackage,
    selectedPackageType,
    selectedDuration,
    discountCode,
    useCredit,
    // invoiceId,
    selectedConversationCount,
    payablePrice,
    paymentInfo,
    // locale,
  } = useSelector(mapState);
  const { getTranslation } = useTranslation('PACKAGE_UPGRADING');
  const { t } = getTranslation();

  const [visible, toggle] = useModal();
  const [checkBeforePurchaseStatus, setCheckBeforePurchaseStatus] =
    useState(false);

  function handleToggle(event) {
    if (event) event.preventDefault();
    toggle();
    // resetForm();
  }

  const handleMakeInvoice = () => {
    const invoice = isPackageUpgrade
      ? {
          isPackageUpgrade,
          isOfficialBillNeeded,
          selectedPackage,
          selectedDuration,
          discountCode,
          selectedPackageType,
          useCredit,
          handleToggle,
        }
      : {
          isPackageUpgrade,
          isOfficialBillNeeded,
          selectedConversationCount,
          handleToggle,
        };
    dispatch(makeInvoiceStart(invoice));
  };

  const handleMakePaymentWithoutOfficialBill = () => {
    const invoiceDataForFaLocale = isPackageUpgrade
      ? {
          isPackageUpgrade,
          isOfficialBillNeeded,
          selectedPackage,
          selectedDuration,
          discountCode,
          useCredit,
          payablePrice,
          selectedPackageType,
        }
      : {
          isPackageUpgrade,
          isOfficialBillNeeded,
          selectedConversationCount,
          payablePrice,
        };

    // const invoiceDataForEngLocale = {
    //   selectedPackageType,
    //   isPackageUpgrade,
    //   selectedDuration,
    //   discountCode,
    //   useCredit,
    //   selectedConversationCount,
    // };

    // if (locale === 'en') {
    //   dispatch(makePaymentWithoutOfficialBillEng(invoiceDataForEngLocale));
    //   return;
    // }

    dispatch(makePaymentWithoutOfficialBill(invoiceDataForFaLocale));
  };

  const checkForBeforePurchaseParameter = () => {
    const needCheck = needToCheckUserInfoForcedFields(
      paymentInfo.data,
      profile.mobile
    );

    setCheckBeforePurchaseStatus(needCheck);
  };

  useEffect(() => {
    checkForBeforePurchaseParameter();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentInfo, profile]);

  const handleCloseUpgradeMethodModal = () => {
    checkForBeforePurchaseParameter();
  };

  const renderSubmitButton = () => {
    // package upgrade and when info does not need to get filled before proceed
    if (!checkBeforePurchaseStatus && isPackageUpgrade) {
      return (
        <UpgradeMethodModal
          isPackageUpgrade={isPackageUpgrade}
          renderCta
          onToggle={handleMakePaymentWithoutOfficialBill}
          toggleUserInfoModalVisible={toggle}
          onCloseUpgradeMethodModal={handleCloseUpgradeMethodModal}
        />
      );
    }

    const handleFunction = checkBeforePurchaseStatus
      ? handleMakeInvoice
      : handleMakePaymentWithoutOfficialBill;

    return (
      <button
        className={clsx('btn', styles.btnPrimary)}
        onClick={handleFunction}
      >
        {t('CONTINUE_PURCHASE')}
      </button>
    );
  };

  return (
    <>
      {renderSubmitButton()}
      {/* user-info form modal for official bill. note that in english version we don't have official bill */}
      <UserInfoModal visible={visible} handleClose={toggle} />
    </>
  );
};

export default InputPaymentInfoModal;
